'use strict'

/** マッピング種別の選択肢（テーブル行の select とモーダルで共通利用）。表示文言はモックアップ data-mapping.html / mapping-tab.js に準拠。 */
export const MAPPING_TYPE_GROUPS = [
  {
    label: '📋 基本',
    options: [
      { value: 'simple', label: 'そのまま取り込む' },
      { value: 'constant', label: '固定値を設定する' }
    ]
  },
  {
    label: '🔄 コード・値の変換',
    options: [
      { value: 'conversion_table', label: 'マスターで変換する（コード→名称など）' },
      { value: 'value_mapping', label: '個別に値を変換する' },
      { value: 'value_mapping_dnd', label: '個別に値を変換する（ドラッグアンドドロップ）' }
    ]
  },
  {
    label: '📅 形式の変換',
    options: [
      { value: 'date_format', label: '日付形式を変換する' },
      { value: 'time_format', label: '時間形式を変換する' }
    ]
  },
  {
    label: '🧮 計算・条件分岐',
    options: [
      { value: 'four_arithmetic', label: '計算して求める（四則演算）' },
      { value: 'single_condition', label: '条件によって値を変える' },
      { value: 'multi_condition', label: '複数の条件を組み合わせる' }
    ]
  }
]

// 複数ファイル種別の組合せでデータ欠損が生じる分類。マッピングは 1 ファイル種別に統一する必要がある。
export const SINGLE_FILE_TYPE_TARGET_GDK_CODES = Object.freeze([
  'GDK-0020',
  'GDK-0021',
  'GDK-0023',
  'GDK-0024',
  'GDK-0025',
  'GDK-0031',
  'GDK-0032',
  'GDK-0033',
  'GDK-0034',
  'GDK-0035',
  'GDK-0036',
  'GDK-0037'
])

export const SINGLE_FILE_TYPE_TARGET_GDK_CODE_SET = new Set(SINGLE_FILE_TYPE_TARGET_GDK_CODES)

// プレビュー系テーブルで空値（null / undefined / 空文字）セルに表示するプレースホルダー。
// マッピング結果CSV（データ検証結果）とマッピング設定モーダルのプレビューで表示を統一する。
export const PREVIEW_EMPTY_CELL_LABEL = '(未入力) 空値'
